import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import classNames from 'classnames';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {PIN_NUMBERS} from '../../../modules/common/consts';
import './AssetInfo.less';
import SelectedDevice from './SelectedDevice';
import GpioInfo from './GpioInfo';
type Props = {
	asset: Asset | null | undefined;
	liveData?: Record<string, any>;
};

const GpioInfos = ({asset, liveData = {}}: Props) => {
	if (!asset) {
		return null;
	}

	return (
		<div className="gpio-infos">
			<label>
				<Trans i18nKey="dashboard.widgets.floorplan.assetinfo.gpios">GPIOs:</Trans>
			</label>
			<div className="gpio-pins" data-testid="gpio-pins">
				{!!asset &&
					PIN_NUMBERS.map((number) => (
						<GpioInfo
							key={number}
							index={number}
							dataTestId={`gpio-info-${number}`}
							mode={liveData[`pin${number}Mode`]}
							status={liveData[`pin${number}Status`]}
						/>
					))}
			</div>
		</div>
	);
};

const AssetInfo = ({asset, liveData = {}}: Props) => {
	const classes = classNames('floorplan-asset-info', {
		'extended-info': !!asset
	});
	return (
		<div className={classes}>
			<SelectedDevice asset={asset} liveData={liveData} />
			<GpioInfos asset={asset} liveData={liveData} />
		</div>
	);
};

export default AssetInfo;
